import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
const FloatingModalContainer = styled.div `
  position: fixed;
  top: ${(props) => props.top}px;
  left: ${(props) => props.left}px;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  scrollbar-width: none;
  padding: 16px;
  widith: fit-content;
  pointer-events: all;
  box-shadow: 0px 6px 20px rgba(25, 25, 26, 0.06),
    0px 2px 12px rgba(25, 25, 26, 0.04);
  overflow-x: hidden;
  border-right: none;
  scroll-behavior: smooth;
  border-radius: 0.8125rem;
  z-index: 10;
  opacity: ${(props) => (props.visible ? 1 : 0)};
  transform: ${(props) => props.visible ? "translateY(0)" : "translateY(-20px)"};
  visibility: ${(props) => (props.visible ? "visible" : "hidden")};
  transition: opacity 0.3s ease, transform 0.3s ease;
`;
const FloatingModal = ({ referenceDiv, isVisible, onClose, width, children, }) => {
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const modalRef = useRef(null);
    const updatePosition = () => {
        if (referenceDiv.current && isVisible) {
            const rect = referenceDiv.current.getBoundingClientRect();
            const modalHeight = modalRef.current ? modalRef.current.offsetHeight : 0;
            const modalWidth = modalRef.current ? modalRef.current.offsetWidth : 0;
            // Calculate the initial position centered around the reference div
            const topPosition = rect.top + window.scrollY + rect.height / 2 - modalHeight / 2;
            const leftPosition = rect.right + 10;
            // Adjust the position if it goes out of the viewport
            const adjustedTop = Math.max(0, // Ensure it does not go above the viewport
            Math.min(topPosition, window.innerHeight - modalHeight // Ensure it does not go below the viewport
            ));
            // Adjust left position to stay within the viewport
            const adjustedLeft = Math.max(0, // Ensure it does not go beyond the left edge
            Math.min(leftPosition, window.innerWidth - modalWidth // Ensure it does not go beyond the right edge
            ));
            setPosition({
                top: adjustedTop,
                left: adjustedLeft,
            });
        }
    };
    useEffect(() => {
        updatePosition(); // Initial positioning when modal is shown
        const handleResize = () => {
            updatePosition(); // Update position on window resize
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [referenceDiv, isVisible]);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current &&
                !modalRef.current.contains(event.target) &&
                referenceDiv.current &&
                !referenceDiv.current.contains(event.target)) {
                onClose();
            }
        };
        if (isVisible) {
            // document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            // document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isVisible, onClose, referenceDiv]);
    return (_jsx(FloatingModalContainer, { ref: modalRef, style: {
            width: width ? `${width}px` : "fit-content",
        }, top: position.top, left: position.left, visible: isVisible, children: children }));
};
export default FloatingModal;
